
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[uri]",
      function () {
        return require("private-next-pages/blog/[uri].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[uri]"])
      });
    }
  